import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date range
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'datepicker', // Datepicker component
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum date set to today
                        },
                    },
                },
            ],
        };

        const center_left = {
            // Center left section of the form
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for product selection
                    name: 'ProductId',
                    localId: 'product:combo',
                    label: _('Producto'), // Label for product
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        const center_right = {
            // Center right section of the form
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for provider selection
                    name: 'ProviderId',
                    localId: 'provider:combo',
                    label: _('Proveedor'), // Label for provider
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        const right = {
            // Right section of the form
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for test selection
                    name: 'IsTest',
                    localId: 'isTest:combo',
                    label: _('Es Test'), // Label for test
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        const upper_section = {
            // Upper section containing all input fields
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_right,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        const buttons = {
            // Button section for actions
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        // Clear action
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Consult action
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event with data
                    },
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            // Wait for webix to be ready
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if condition is true
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Attach event after rendering Datepicker
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
    }
}

// FILE DOCUMENTED
